import { EntityTypeArray } from '../../../../TraffickingPage/hooks/makePageDrawerPlugin';
import type { AdsEntities, LineItemsEntities } from '../../types';

export const getCountText = (entities: LineItemsEntities | AdsEntities, entityType: EntityTypeArray): string => {
  return entityType === EntityTypeArray.LINE_ITEM_ARRAY
    ? `${entities.length} ${entities.length === 1 ? 'LINE ITEM' : 'LINE ITEMS'}`
    : `${entities.length} ${entities.length === 1 ? 'AD' : 'ADS'}`;
};
